"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var observable_1 = require("./observable");
var addon_manager_1 = require("./addon-manager");
var player_providers_1 = require("./player-providers");
var default_manifest_loader_1 = require("./manifest-loader/default-manifest-loader");
var native_load_data_1 = require("./native-load-data");
var StopReason;
(function (StopReason) {
    StopReason[StopReason["UserInput"] = 1] = "UserInput";
    StopReason[StopReason["Error"] = 2] = "Error";
    StopReason[StopReason["Finished"] = 3] = "Finished";
})(StopReason = exports.StopReason || (exports.StopReason = {}));
var PlayerState;
(function (PlayerState) {
    PlayerState[PlayerState["Stopped"] = 0] = "Stopped";
    PlayerState[PlayerState["Playing"] = 1] = "Playing";
    PlayerState[PlayerState["Paused"] = 2] = "Paused";
    PlayerState[PlayerState["Rebuffering"] = 3] = "Rebuffering";
    PlayerState[PlayerState["Finished"] = 4] = "Finished";
    PlayerState[PlayerState["Seeking"] = 5] = "Seeking";
    PlayerState[PlayerState["Loading"] = 6] = "Loading";
})(PlayerState = exports.PlayerState || (exports.PlayerState = {}));
var ContentType;
(function (ContentType) {
    ContentType[ContentType["Movies"] = 0] = "Movies";
    ContentType[ContentType["Entertainment"] = 1] = "Entertainment";
    ContentType[ContentType["Sports"] = 2] = "Sports";
    ContentType[ContentType["Kids"] = 3] = "Kids";
    ContentType[ContentType["News"] = 4] = "News";
    ContentType[ContentType["Other"] = 5] = "Other";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var PlayoutRect = (function () {
    function PlayoutRect() {
    }
    return PlayoutRect;
}());
exports.PlayoutRect = PlayoutRect;
var AdPositionType;
(function (AdPositionType) {
    AdPositionType[AdPositionType["Preroll"] = 0] = "Preroll";
    AdPositionType[AdPositionType["Midroll"] = 1] = "Midroll";
    AdPositionType[AdPositionType["Postroll"] = 2] = "Postroll";
})(AdPositionType = exports.AdPositionType || (exports.AdPositionType = {}));
var AdStatus;
(function (AdStatus) {
    AdStatus[AdStatus["Unwatched"] = 0] = "Unwatched";
    AdStatus[AdStatus["Watched"] = 1] = "Watched";
    AdStatus[AdStatus["Skipped"] = 2] = "Skipped";
    AdStatus[AdStatus["Errored"] = 3] = "Errored";
})(AdStatus = exports.AdStatus || (exports.AdStatus = {}));
var AdStreamType;
(function (AdStreamType) {
    AdStreamType[AdStreamType["InStream"] = 0] = "InStream";
    AdStreamType[AdStreamType["Separate"] = 1] = "Separate";
})(AdStreamType = exports.AdStreamType || (exports.AdStreamType = {}));
var AdPlayerType;
(function (AdPlayerType) {
    AdPlayerType[AdPlayerType["Main"] = 0] = "Main";
    AdPlayerType[AdPlayerType["Separate"] = 1] = "Separate";
})(AdPlayerType = exports.AdPlayerType || (exports.AdPlayerType = {}));
var CommonPlayer = (function () {
    function CommonPlayer() {
        var _this = this;
        this.isSessionActive = false;
        this.currentState = PlayerState.Stopped;
        this.stateObservable = new observable_1.Observable();
        this.cdnObservable = new observable_1.Observable();
        this.bitrateObservable = new observable_1.Observable();
        this.currentPositionObservable = new observable_1.Observable();
        this.durationObservable = new observable_1.Observable();
        this.bufferInfoObservable = new observable_1.Observable();
        this.availableAudioTracksObservable = new observable_1.Observable();
        this.availableSubtitlesTracksObservable = new observable_1.Observable();
        this.errorObservable = new observable_1.Observable();
        this.warningObservable = new observable_1.Observable();
        this.streamMedataObservable = new observable_1.Observable();
        this.currentAudioTrackObservable = new observable_1.Observable();
        this.currentSubtitlesTrackObservable = new observable_1.Observable();
        this.subtitlesTextObservable = new observable_1.Observable();
        this.sessionStateObservable = new observable_1.Observable();
        this.sessionStartedObservable = new observable_1.Observable();
        this.sessionEndedObservable = new observable_1.Observable();
        this.adDataRequestedObservable = new observable_1.Observable();
        this.adBreakStartedObservable = new observable_1.Observable();
        this.adStartedObservable = new observable_1.Observable();
        this.adFinishedObservable = new observable_1.Observable();
        this.adBreakFinishedObservable = new observable_1.Observable();
        this.adErrorObservable = new observable_1.Observable();
        this.volumeObservable = new observable_1.Observable();
        this.isPlayingAdvert = false;
        this.provider = new player_providers_1.DefaultPlayerProvider();
        this.manifestLoader = new default_manifest_loader_1.DefaultManifestLoader();
        this.addonManager = new addon_manager_1.AddonManager(this);
        this.sessionStateObservable.registerObserver(function (isActive) {
            _this.isSessionActive = isActive;
            if (isActive) {
                _this.sessionStartedObservable.notifyObservers();
            }
            else {
                _this.sessionEndedObservable.notifyObservers();
            }
        }, this);
        this.onAdBreakStarted(function (adBreak) {
            _this.isPlayingAdvert = true;
        }, this);
        this.onAdBreakFinished(function (adBreak) {
            _this.isPlayingAdvert = false;
        }, this);
        this.onFinished(function () {
            if (_this.isPlayingAdvert) {
                return;
            }
            setTimeout(function () {
                _this.endSessionInternal(StopReason.Finished);
            });
        }, this);
        this.onStateChanged(function (state) {
            _this.currentState = state;
        }, this);
        this.onBitrateChange(function (bitrateLevel) {
            _this.currentBitRateLevel = bitrateLevel;
        }, this);
    }
    CommonPlayer.convertPlayoutRequestToNativeLoadData = function (playoutRequestData) {
        return {
            streamFormatType: playoutRequestData.streamFormatType,
            autoplay: playoutRequestData.autoplay,
            muted: playoutRequestData.muted,
            volume: playoutRequestData.volume,
            type: playoutRequestData.type,
            position: playoutRequestData.position || 0,
            defaultAudioLanguage: playoutRequestData.defaultAudioLanguage,
            cdn: playoutRequestData.cdns && playoutRequestData.cdns.length ? playoutRequestData.cdns[0] : null,
            download: playoutRequestData.download,
            drmConfiguration: playoutRequestData.drmConfiguration,
            videoHTMLContainerInfo: playoutRequestData.videoHTMLContainerInfo,
            custom: __assign({}, (playoutRequestData.playoutRect && { playoutRect: playoutRequestData.playoutRect }), playoutRequestData.custom),
            abrConfig: playoutRequestData.abrConfig || {},
        };
    };
    CommonPlayer.prototype.setPlayerProvider = function (provider) {
        this.provider = provider;
    };
    CommonPlayer.prototype.setManifestLoader = function (loader) {
        this.manifestLoader = loader;
    };
    CommonPlayer.prototype.setAudioTrack = function (track) {
        this.addonManager.nativePlayerWillSetAudioTrack(track);
        this.nativeSetAudioTrack(track);
    };
    CommonPlayer.prototype.getManifest = function () {
        return this.manifestLoader.getManifest();
    };
    CommonPlayer.prototype.enableSubtitles = function (track) {
        this.nativeEnableSubtitles(track);
    };
    CommonPlayer.prototype.disableSubtitles = function () {
        this.nativeDisableSubtitles();
    };
    CommonPlayer.prototype.setAddons = function (addons) {
        var _a;
        (_a = this.addonManager).setAddons.apply(_a, addons);
    };
    CommonPlayer.prototype.startSession = function (param) {
        var _this = this;
        if (this.provider instanceof player_providers_1.DefaultPlayerProvider) {
            var playoutRequestData = param;
            this.provider.setCurrentPlayoutRequestData(playoutRequestData);
        }
        var assetSignature = param;
        return this.waitForSessionCanStart()
            .then(function () {
            return _this.provider.getPlayoutRequestData(assetSignature, player_providers_1.PlayoutRequestReason.New);
        })
            .then(function (playoutRequestData) {
            _this.validatePlayoutRequestData(playoutRequestData);
            return _this.addonManager.sessionWillStart(playoutRequestData).then(function () {
                _this.sessionStateObservable.notifyObservers(true);
                return _this.addonManager.sessionDidStart(playoutRequestData);
            });
        })
            .then(function (modifiedPlayoutRequestData) {
            var nativeLoadData = CommonPlayer.convertPlayoutRequestToNativeLoadData(modifiedPlayoutRequestData);
            _this.loadAndNotify(nativeLoadData, modifiedPlayoutRequestData);
        })
            .catch(function (error) {
            _this.notifyError(error);
        });
    };
    CommonPlayer.prototype.endSession = function () {
        return this.endSessionInternal(StopReason.UserInput);
    };
    CommonPlayer.prototype.play = function () {
        this.addonManager.nativePlayerWillPlay();
        this.nativePlay();
    };
    CommonPlayer.prototype.pause = function () {
        this.addonManager.nativePlayerWillPause();
        this.nativePause();
    };
    CommonPlayer.prototype.stop = function (reason) {
        if (!reason) {
            console.warn('[PlayerFramework] WARNING: "player.stop()" has been deprecated and will be removed in an upcoming major version. For more information, please visit https://github.com/sky-uk/client-lib-js-player-framework/blob/master/docs/migrations.md#ending-a-session');
            this.endSessionInternal(StopReason.UserInput);
            return;
        }
        if (this.currentState === PlayerState.Stopped) {
            return;
        }
        this.addonManager.nativePlayerWillStop(reason);
        this.nativeStop();
    };
    CommonPlayer.prototype.skipCurrentAdBreak = function () {
        this.addonManager.skipCurrentAdBreak();
    };
    CommonPlayer.prototype.updateAdProfileLimits = function (adProfileLimits) {
        this.addonManager.updateAdProfileLimits(adProfileLimits);
    };
    CommonPlayer.prototype.seek = function (positionSeconds) {
        var _this = this;
        this.addonManager.nativePlayerWillSeek(positionSeconds);
        this.nativeSeek(positionSeconds)
            .then(function () {
            _this.addonManager.nativePlayerDidSeek();
        })
            .catch(function () {
            _this.addonManager.nativePlayerDidSeek();
        });
    };
    CommonPlayer.prototype.setVolume = function (volume) {
        this.nativeSetVolume(volume);
        this.notifyVolumeChanged(volume);
    };
    CommonPlayer.prototype.setAbrConfig = function (config) {
        var newBitRateLevel = __assign({}, this.currentBitRateLevel);
        newBitRateLevel.config = __assign({}, newBitRateLevel.config, config);
        this.nativeSetAbrConfig(config);
        this.currentBitRateLevel = newBitRateLevel;
    };
    CommonPlayer.prototype.setMute = function (isMute) {
        this.nativeSetMute(isMute);
    };
    CommonPlayer.prototype.waitForState = function (state) {
        var _this = this;
        if (this.currentState === state) {
            return Promise.resolve();
        }
        var callbackOwner = {};
        return new Promise(function (resolve, reject) {
            _this.onStateChanged(function (newState) {
                if (newState === state) {
                    resolve();
                    _this.removeEventListeners(callbackOwner);
                }
            }, callbackOwner);
            _this.onError(function (error) {
                reject(error);
                _this.removeEventListeners(callbackOwner);
            }, callbackOwner);
        });
    };
    CommonPlayer.prototype.waitForSessionCanStart = function () {
        var _this = this;
        if (!this.isSessionActive) {
            return Promise.resolve();
        }
        return new Promise(function (resolve) {
            var callbackOwner = {};
            _this.sessionStateObservable.registerObserver(function (isActive) {
                if (isActive) {
                    return;
                }
                _this.sessionStateObservable.unregisterObservers(callbackOwner);
                setTimeout(function () {
                    resolve();
                });
            }, callbackOwner);
        });
    };
    CommonPlayer.prototype.loadAndNotify = function (nativeLoadData, modifiedPlayoutRequestData) {
        var playerWillLoad = this.addonManager.nativePlayerWillLoad(nativeLoadData, modifiedPlayoutRequestData);
        if (playerWillLoad) {
            this.addonManager.nativePlayerDidLoad(nativeLoadData, modifiedPlayoutRequestData);
            this.manifestLoader.notifyNativeLoad(nativeLoadData);
            this.nativeLoad(nativeLoadData);
        }
    };
    CommonPlayer.prototype.raiseErrorAndStop = function (error) {
        this.notifyError(error);
        this.stop(StopReason.Error);
    };
    CommonPlayer.prototype.onSessionStarted = function (callback, callbackOwner) {
        this.sessionStartedObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onSessionEnded = function (callback, callbackOwner) {
        this.sessionEndedObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onStateChanged = function (callback, callbackOwner) {
        this.stateObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onStopped = function (callback, callbackOwner) {
        this.registerStateObserver(PlayerState.Stopped, callback, callbackOwner);
    };
    CommonPlayer.prototype.onLoading = function (callback, callbackOwner) {
        this.registerStateObserver(PlayerState.Loading, callback, callbackOwner);
    };
    CommonPlayer.prototype.onPlaying = function (callback, callbackOwner) {
        this.registerStateObserver(PlayerState.Playing, callback, callbackOwner);
    };
    CommonPlayer.prototype.onPaused = function (callback, callbackOwner) {
        this.registerStateObserver(PlayerState.Paused, callback, callbackOwner);
    };
    CommonPlayer.prototype.onRebuffering = function (callback, callbackOwner) {
        this.registerStateObserver(PlayerState.Rebuffering, callback, callbackOwner);
    };
    CommonPlayer.prototype.onSeeking = function (callback, callbackOwner) {
        this.registerStateObserver(PlayerState.Seeking, callback, callbackOwner);
    };
    CommonPlayer.prototype.onFinished = function (callback, callbackOwner) {
        this.registerStateObserver(PlayerState.Finished, callback, callbackOwner);
    };
    CommonPlayer.prototype.onCdnSelected = function (callback, callbackOwner) {
        this.cdnObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onBitrateChange = function (callback, callbackOwner) {
        this.bitrateObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onCurrentPositionChanged = function (callback, callbackOwner) {
        this.currentPositionObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onDurationChanged = function (callback, callbackOwner) {
        this.durationObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onBufferInfoChanged = function (callback, callbackOwner) {
        this.bufferInfoObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onAvailableAudioTracksChanged = function (callback, callbackOwner) {
        this.availableAudioTracksObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onAvailableSubtitlesTracksChanged = function (callback, callbackOwner) {
        this.availableSubtitlesTracksObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onError = function (callback, callbackOwner) {
        this.errorObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onWarning = function (callback, callbackOwner) {
        this.warningObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onCurrentAudioTrackChanged = function (callback, callbackOwner) {
        this.currentAudioTrackObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onCurrentSubtitlesTrackChanged = function (callback, callbackOwner) {
        this.currentSubtitlesTrackObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onSubtitlesTextChanged = function (callback, callbackOwner) {
        this.subtitlesTextObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onStreamMetadataReceived = function (callback, callbackOwner) {
        this.streamMedataObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onAdBreakStarted = function (callback, callbackOwner) {
        this.adBreakStartedObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onAdDataRequested = function (callback, callbackOwner) {
        this.adDataRequestedObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onAdStarted = function (callback, callbackOwner) {
        this.adStartedObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onAdFinished = function (callback, callbackOwner) {
        this.adFinishedObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onAdBreakFinished = function (callback, callbackOwner) {
        this.adBreakFinishedObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onAdError = function (callback, callbackOwner) {
        this.adErrorObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.onVolumeChanged = function (callback, callbackOwner) {
        this.volumeObservable.registerObserver(callback, callbackOwner);
    };
    CommonPlayer.prototype.removeEventListeners = function (callbackOwner) {
        this.bitrateObservable.unregisterObservers(callbackOwner);
        this.currentPositionObservable.unregisterObservers(callbackOwner);
        this.durationObservable.unregisterObservers(callbackOwner);
        this.bufferInfoObservable.unregisterObservers(callbackOwner);
        this.errorObservable.unregisterObservers(callbackOwner);
        this.warningObservable.unregisterObservers(callbackOwner);
        this.stateObservable.unregisterObservers(callbackOwner);
        this.availableAudioTracksObservable.unregisterObservers(callbackOwner);
        this.availableSubtitlesTracksObservable.unregisterObservers(callbackOwner);
        this.subtitlesTextObservable.unregisterObservers(callbackOwner);
        this.currentAudioTrackObservable.unregisterObservers(callbackOwner);
        this.currentSubtitlesTrackObservable.unregisterObservers(callbackOwner);
        this.streamMedataObservable.unregisterObservers(callbackOwner);
        this.sessionStateObservable.unregisterObservers(callbackOwner);
        this.sessionStartedObservable.unregisterObservers(callbackOwner);
        this.sessionEndedObservable.unregisterObservers(callbackOwner);
        this.adBreakStartedObservable.unregisterObservers(callbackOwner);
        this.adDataRequestedObservable.unregisterObservers(callbackOwner);
        this.adStartedObservable.unregisterObservers(callbackOwner);
        this.adFinishedObservable.unregisterObservers(callbackOwner);
        this.adBreakFinishedObservable.unregisterObservers(callbackOwner);
        this.adErrorObservable.unregisterObservers(callbackOwner);
        this.volumeObservable.unregisterObservers(callbackOwner);
    };
    CommonPlayer.prototype.notifyStateChange = function (state) {
        var isValidState = state in PlayerState;
        if (!isValidState) {
            throw new Error('unknown state: ' + state);
        }
        this.stateObservable.notifyObservers(state);
    };
    CommonPlayer.prototype.notifyCdnSelected = function (cdn) {
        this.cdnObservable.notifyObservers(cdn);
    };
    CommonPlayer.prototype.notifyBitrateChanged = function (bitrateLevel) {
        var newBitRateLevel = __assign({}, this.currentBitRateLevel, bitrateLevel);
        this.bitrateObservable.notifyObservers(newBitRateLevel);
    };
    CommonPlayer.prototype.notifyDurationChanged = function (duration) {
        this.durationObservable.notifyObservers(duration);
    };
    CommonPlayer.prototype.notifyBufferInfoChanged = function (bufferInfo) {
        this.bufferInfoObservable.notifyObservers(bufferInfo);
    };
    CommonPlayer.prototype.notifyError = function (error) {
        if (error && error.isInitiallyFatal === undefined) {
            error.isInitiallyFatal = Boolean(error.isFatal);
        }
        var errorToReport = this.addonManager.nativePlayerDidError(error);
        if (errorToReport.isFatal) {
            this.errorObservable.notifyObservers(errorToReport);
        }
        else {
            this.warningObservable.notifyObservers(errorToReport);
        }
        if (error && error.isInitiallyFatal) {
            this.endSessionInternal(StopReason.Error);
        }
    };
    CommonPlayer.prototype.notifyWarning = function (code, message) {
        this.notifyError({
            code: code,
            message: message,
            isFatal: false,
        });
    };
    CommonPlayer.prototype.notifyCurrentPositionChanged = function (currentPosition) {
        this.currentPositionObservable.notifyObservers(currentPosition);
    };
    CommonPlayer.prototype.notifyCurrentAudioTrackChanged = function (track) {
        this.currentAudioTrackObservable.notifyObservers(track);
    };
    CommonPlayer.prototype.notifyCurrentSubtitlesTrackChanged = function (track) {
        this.currentSubtitlesTrackObservable.notifyObservers(track);
    };
    CommonPlayer.prototype.notifyAvailableSubtitlesTracksChanged = function (tracks) {
        this.availableSubtitlesTracksObservable.notifyObservers(tracks);
    };
    CommonPlayer.prototype.notifyAvailableAudioTracksChanged = function (tracks) {
        this.availableAudioTracksObservable.notifyObservers(tracks);
    };
    CommonPlayer.prototype.notifySubtitlesTextChanged = function (textData) {
        this.subtitlesTextObservable.notifyObservers(textData);
    };
    CommonPlayer.prototype.notifyStreamMetadataReceived = function (metadata) {
        this.streamMedataObservable.notifyObservers(metadata);
    };
    CommonPlayer.prototype.notifyAdBreakStarted = function (adBreak) {
        this.adBreakStartedObservable.notifyObservers(adBreak);
    };
    CommonPlayer.prototype.notifyAdDataRequested = function () {
        this.adDataRequestedObservable.notifyObservers();
    };
    CommonPlayer.prototype.notifyAdStarted = function (ad, adBreak) {
        this.adStartedObservable.notifyObservers({ ad: ad, adBreak: adBreak });
    };
    CommonPlayer.prototype.notifyAdFinished = function (ad, adBreak) {
        this.adFinishedObservable.notifyObservers({ ad: ad, adBreak: adBreak });
    };
    CommonPlayer.prototype.notifyAdBreakFinished = function (adBreak) {
        this.adBreakFinishedObservable.notifyObservers(adBreak);
    };
    CommonPlayer.prototype.notifyAdError = function (error, ad, adBreak) {
        this.adErrorObservable.notifyObservers({ error: error, ad: ad, adBreak: adBreak });
    };
    CommonPlayer.prototype.notifyVolumeChanged = function (volume) {
        this.volumeObservable.notifyObservers(volume);
    };
    CommonPlayer.prototype.sessionDidEnd = function (reason) {
        this.addonManager.sessionDidEnd(reason);
        this.currentPositionObservable.reset();
        this.durationObservable.reset();
        this.bitrateObservable.reset();
        this.currentAudioTrackObservable.reset();
        this.availableAudioTracksObservable.reset();
        this.currentSubtitlesTrackObservable.reset();
        this.availableSubtitlesTracksObservable.reset();
        this.isPlayingAdvert = false;
        this.sessionStateObservable.notifyObservers(false);
    };
    CommonPlayer.prototype.validatePlayoutRequestData = function (playoutRequestData) {
        if (!playoutRequestData) {
            throw { message: 'playoutRequestData - empty', code: '', isFatal: true };
        }
        if (!Number.isInteger(playoutRequestData.type)) {
            throw {
                message: 'playoutRequestData - missing or invalid playback type',
                code: '',
                isFatal: true,
            };
        }
        var isOttStream = playoutRequestData.type === native_load_data_1.PlaybackType.Vod || playoutRequestData.type === native_load_data_1.PlaybackType.Live;
        var hasCdnUrl = playoutRequestData.cdns && playoutRequestData.cdns.length > 0 && Boolean(playoutRequestData.cdns[0].url);
        if (isOttStream && !hasCdnUrl) {
            throw {
                message: 'playoutRequestData - ott playout request with no cdn with a valid url',
                code: '',
                isFatal: true,
            };
        }
    };
    CommonPlayer.prototype.registerStateObserver = function (forState, callback, callbackOwner) {
        var stateCallback = function (state) {
            if (state === forState) {
                callback();
            }
        };
        this.stateObservable.registerObserver(stateCallback, callbackOwner);
    };
    CommonPlayer.prototype.endSessionInternal = function (reason) {
        var _this = this;
        this.stop(reason);
        return this.waitForState(PlayerState.Stopped).then(function () {
            var shouldSessionEnd = reason === StopReason.UserInput || _this.addonManager.shouldSessionEnd(reason);
            if (!shouldSessionEnd) {
                return Promise.resolve();
            }
            else {
                return _this.addonManager.sessionWillEnd(reason).then(function () {
                    _this.sessionDidEnd(reason);
                }, function () {
                    _this.sessionDidEnd(reason);
                });
            }
        });
    };
    return CommonPlayer;
}());
exports.CommonPlayer = CommonPlayer;
